export function isOffer(product, offers) {
    const productAsOffer = offers.filter(e => e.active).find(e => e.product_details.id === product.id)

    return productAsOffer
}